<template>

  <vs-popup fullscreen :active.sync="isActiveLocal" title="Yeni Reçete Ekle" v-esc="escape">
    <div class="con-exemple-prompt" @keyup.enter="submitData">
      <vs-input id="name" name="İsim" v-validate="'required'" v-model="newRecipe.name" class="w-full"
                icon-pack="feather" icon="icon-user" label-placeholder="İsim"/>
      <span class="text-danger text-sm" v-show="errors.has('İsim')">{{ errors.first("İsim")}}</span>
      <vs-textarea id="description" name="Açıklama" v-model="newRecipe.description" class="w-full mt-4 mb-0"
                   label="Açıklama"/>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="12">
          <v-select :disabled="productExtras.length == 0" id="product" name="Ekstralar" multiple
                    v-model="newRecipe.productExtras" itemid="id" label="name" placeholder="Ekstra Seçimi"
                    :options="productExtras" class="mt-4 w-full" :clearable="true">
          </v-select>
        </vs-col>
      </vs-row>
      <vs-table ref="table" :data="newRecipe.recipeSteps" class="py-5">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        </div>
        <template slot="thead">

          <vs-th class="w-1/3">
            Hammadde
          </vs-th>
          <vs-th class="w-1/6">
            Miktar
          </vs-th>
          <vs-th class="w-1/6">
            Sıra
          </vs-th>
          <vs-th class="w-1/6">
            Kaldırılabilir
          </vs-th>
          <vs-th class="w-1/6">
            Birim
          </vs-th>
          <vs-th class="w-1/6">
            Birim Fiyat
          </vs-th>
          <vs-th class="w-1/6">
            Tedarikçi Adı
          </vs-th>
          <vs-th>İşlem</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <v-select :disabled="rawMaterials.length == 0" id="product" name="Hammadde" v-validate="'required'"
                        v-model="newRecipe.recipeSteps[indextr].rawMaterial" itemid="id" label="name"
                        placeholder="Hammadde Seçimi.." :options="rawMaterials" :clearable="false"></v-select>
              <span class="text-danger text-sm" v-show="errors.has('Hammadde')">{{ errors.first("Hammadde")}}</span>
            </vs-td>

            <vs-td>
              <vs-input id="quantity" :name="(indextr+1) + '.Miktar'"
                        v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                        v-if="newRecipe.recipeSteps[indextr].rawMaterial.name"
                        v-model="newRecipe.recipeSteps[indextr].unitPartQuantity" class="w-full"/>
              <span class="text-danger text-sm"
                    v-show="errors.has((indextr+1) + '.Miktar')">{{ errors.first((indextr+1) + ".Miktar")}}</span>
            </vs-td>
            <vs-td>
              <vs-input id="index" :name="(indextr+1) + '.Sıra'"
                        v-validate="'numeric|required'"
                        v-if="newRecipe.recipeSteps[indextr].rawMaterial.name"
                        v-model="newRecipe.recipeSteps[indextr].index" class="w-full"/>
              <span class="text-danger text-sm"
                    v-show="errors.has((indextr+1) + '.Sıra')">{{ errors.first((indextr+1) + ".Sıra")}}</span>
            </vs-td>

            <vs-td>
              <vs-checkbox color="primary" v-model="tr.isRemovable" />
            </vs-td>

            <vs-td>
              <p v-if="newRecipe.recipeSteps[indextr].rawMaterial.unit">{{newRecipe.recipeSteps[indextr].rawMaterial.unit.name}}</p>
            </vs-td>

            <vs-td>
                <span
                  v-if="newRecipe.recipeSteps[indextr].rawMaterial.name ">{{$toCurrency(newRecipe.recipeSteps[indextr].rawMaterial.buyPrice, 4)}}
                  </span>
            </vs-td>

            <vs-td>
              <p class="product-category" v-if="newRecipe.recipeSteps[indextr].rawMaterial.name && tr.rawMaterial.supplier">
                {{ tr.rawMaterial.supplier.name }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                            @click.stop="newRecipe.recipeSteps.splice(indextr,1)"/>
            </vs-td>
          </vs-tr>
          </tbody>
          <vs-button class="m-4" type="gradient" icon-pack="feather" icon="icon-plus" color="primary"
                     @click="newRecipe.recipeSteps.push({unit : {},rawMaterial : { alternateUnits : []}});">
          </vs-button>
        </template>
      </vs-table>
      <vs-row vs-type="flex" vs-justify="space-between" vs-w="12" class="mt-4">
        <vs-button size="large" style="margin-right:20px;" type="gradient" color="danger" @click="isActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button size="large" v-if="this.newRecipe.id" class="mr-auto" type="gradient" color="warning" @click="copyData">
          Kopyala
        </vs-button>
        <vs-button type="gradient" :disabled="!newRecipe.recipeSteps || newRecipe.recipeSteps.length == 0" icon-pack="feather" icon="icon-save" class="ml-auto" color="success"
                   @click="submitData" size="large">Kaydet
        </vs-button>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
  import {
    getRawMaterialNameList
  } from "@/api/RawMaterial";
  import {
    filterExtraNameList
  } from "@/api/Filter";
  import {
    createNewRecipe,
    updateRecipe,
    copyRecipe
  } from "@/api/Recipe";
/* eslint-disable */
  export default {
    props: {
      isActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        newRecipe: {
          recipeSteps: []
        },
        rawMaterials: [],
        productExtras: [],

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      };
    },
    methods: {
      escape(){
        if(this.isActiveLocal == true) this.isActiveLocal = false;
      },
      getRawMaterialNameList: function() {
        getRawMaterialNameList(this.filterOptions).then(res => {
          if (res && res.status == 200) {
            this.rawMaterials = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hammaddeler Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      getProductExtraList: async function() {
        this.productExtras = await filterExtraNameList();
      },
      initValues() {
        this.newRecipe = {
          recipeSteps: []
        };
      },
      copyData: async function(){
        copyRecipe(this.newRecipe).then(res => {
          if (res && res.status == 200) {
            this.$store.dispatch("recipe/copyRecipe", res.data).then(() => {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Reçete Kopyalama Başarılı ! "
              });
              this.$emit("close");
              this.initValues();
              this.$validator.reset();
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Reçete Kopyalam Başarısız ! "
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası ! "
          });
        });
      },
      submitData: async function() {
        let checker;
        checker = await this.$validator.validateAll();
        if (checker) {
          this.newRecipe.totalBuyPrice = this.newRecipe.totalBuyPrice ? parseFloat(this.newRecipe.totalBuyPrice) : 0;
          this.newRecipe.recipeSteps.forEach(x=> {
            x.index = parseInt(x.index)
            x.unitPartQuantity = parseFloat(x.unitPartQuantity);
          })
          if (this.newRecipe.id) {
            updateRecipe(this.newRecipe).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("recipe/updateRecipe", res.data).then(() => {
                  this.$vs.notify({
                    color: "success",
                    title: "Başarılı !",
                    text: "Reçete Güncelleme Başarılı ! "
                  });
                  this.$emit("close");
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Reçete Güncelleme Başarısız ! "
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası ! "
              });
            });
          } else {
            this.newRecipe.id = 0;
            createNewRecipe(this.newRecipe).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("recipe/addRecipe", res.data).then(() => {
                  this.$vs.notify({
                    color: "success",
                    title: "Başarılı ! ",
                    text: "Reçete Oluşturma Başarılı ! "
                  });
                  this.$emit("close");
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Reçete Oluşturma Başarısız !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        }
      },
      getCurrentPage(currentx) {
        this.currentPage = currentx - 1;
      }
    },
    computed: {
      isActiveLocal: {
        get() {
          return this.isActive;
        },
        set(val) {
          if (!val) {
            this.$emit("close");
            this.initValues();
            this.$validator.reset();
          }
        }
      }
    },
    mounted: function() {
      this.getProductExtraList();
      this.getRawMaterialNameList();
    },
    created: function() {
    },
    watch: {
      isActive: function(val) {
        if (!val) return;
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newRecipe = _.cloneDeep(this.data);
        }
      }
    }
  };

</script>

<style>
  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: static !important;
  }

</style>
